<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >在线文档</span>
      <!-- <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >测试工具</span> -->
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";


import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'network/getInfo';
export default {
  components: { onlineDoc , apiTestDoc },
  data() { 
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: "根据地址查询平台的网点信息和三段码信息",
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
       postDataList:[
            
        //   请求头参数
            {
                title:'Headers',
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: "接入方在平台的api账户标识"},
                    {name: "digest",type: "String",require: "Y",normal: "",describe: "签名字符串"},
                    {name: "timestamp",type: "Number",require: "Y",normal: "",describe: "时间戳，毫秒"}
                    ]
            },
             { 
                title:'请求参数', 
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: "业务参数",describe: "业务参数模块内json格式的string类型",},
                ]
            },
            {
              title:"业务参数",
              value:[
                {name: "Body",type: "Object",require: "Y",normal: "",describe: "业务参数"},
                {name: "province",type: "String(32)",require: "Y",normal: "",describe: "省份名称"},
                {name: "city",type: "String(32)",require: "Y",normal: "",describe: "城市名称"},
                {name: "area",type: "String(32)",require: "Y",normal: "",describe: "区县名称"},
                {name: "details",type: "String(32)",require: "Y",normal: "",describe: "详细地址"}
              ]
            }

        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[
            
        //   响应参数
            {
                title:'响应参数',
                value:[
                    { name: "code",type: "String", require: "Y",normal: "",describe: "返回码，见附录",},
                    {name: "msg",type: "String",require: "Y",normal: "",describe: "描述",},
                    {name: "data",type: "Object",require: "Y",normal: "",describe: "业务数据",},
                  ]
            },
            {
              title:"data类型说明",
              value:[
                  {name: "networkName",type: "String(32)",require: "N",normal: "",describe: "网点名称"},
                  {name: "networkProvince",type: "String(32)",require: "N",normal: "",describe: "网点省"},
                  {name: "networkCity",type: "String(32)",require: "N",normal: "",describe: "网点市"},
                  {name: "networkArea",type: "String(32)",require: "N",normal: "",describe: "网点区"},
                  {name: "mobile",type: "String(32)",require: "N",normal: "",describe: "网点联系电话"},
                  {name: "networkAddress",type: "String(32)",require: "N",normal: "",describe: "网点地址"},
                  {name: "full",type: "String(32)",require: "N",normal: "",describe: "三段码信息"}
                ]
            }

        ],
        //请求示例
        requestCode: `Header：
    apiAccount=1627
    digest=U40e5sumorgd3YgZzU61Mw==
    timestamp=1565238848921

Body：
    bizContent={
      "area":"九龙坡区",
      "city":"重庆",
      "details":"金科绿韵康城2栋11-4",
      "province":"重庆"
      }`,
        //返回示例
        responseCode: JSON.parse(`{
    "code": "1",
    "msg": "success",
    "data": {
        "networkName": "上海青浦华新网点",
        "mobile": "13800000000",
        "networkAddress": "沈阳市沈河区小南街六合巷",
        "full": "382  G400-28  555",
        "networkProvince": "辽宁省",
        "networkCity": "沈阳市",
        "networkArea": "沈河区"
    }
}`),

        //错误代码提示
        errcodeJson: []
      },

      apiTestData: {
          _headerData: {
            apiAccount: "1001",
            digest: "U40e5sumorgd3YgZzU61Mw==",
            timestamp: "1565238848921",
          },
          data:{
             bizContent: `{"area":"九龙坡区","city":"重庆","details":"金科绿韵康城2栋11-4","province":"重庆"}`,
          },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
        //错误代码提示
        errcodeJson: []
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>